import React, { FC } from "react";
import { useIsMobile } from "src/hooks/viewport/useViewportCategory";
import { FlowioInputType } from "../../../../globalTypes";
import FlowioInput, { FlowioInputProps } from "../../inputs/FlowioInput";
import { FlatFlowioInputProps } from "../../inputs/FlowioInput/types";
import {
  ErrorLabel,
  InputContainer,
  InputWrapper,
  Label,
  LabelContainer,
} from "../styledComponents";

export type Props = {
  label: string;
  vertical?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors?: any;
  dataCy?: string;
  autoComplete?: boolean;
} & FlowioInputProps;

const InputForm: FC<Props> = ({ label, vertical, errors, dataCy, ...rest }) => {
  const { type, name } = rest as FlatFlowioInputProps;
  const isMobile = useIsMobile();

  const isVertical = vertical || isMobile;

  return (
    <InputContainer data-cy="input-container" vertical={isVertical}>
      <LabelContainer
        vertical={isVertical}
        password={rest.type === FlowioInputType.Password}
        data-cy="label-container"
      >
        <Label htmlFor={name} data-cy="label">
          {label || name}
        </Label>
      </LabelContainer>
      <InputWrapper vertical={isVertical}>
        <FlowioInput {...rest} />
        {name && errors && errors[name]?.message && (
          <ErrorLabel
            htmlFor={name}
            password={type === FlowioInputType.Password}
          >
            {errors[name].message}
          </ErrorLabel>
        )}
      </InputWrapper>
    </InputContainer>
  );
};

export default InputForm;
export type InputFormProps = Props;
